export default {
    data() {
        return {
            searchContent: "",
            pageIndex: 1,
            pageSize: 12,
            total: 0,
            tableData: [],
            multipleSelection: [],
            dialogManageShow: false,
            manageForm: {},
            postList: [],
            date: null
        }
    },
    mounted: function () {
        this.query()
    },
    methods: {
        /**
         * 点击事件
         * @param {*} id 
         */
        clickEvent: function (id) {
            switch (id) {
                case "search": //搜索
                    this.pageIndex = 1;
                    this.query();
                    break;
                case "add": //添加
                    this.queryPost();
                    this.manageForm = { duration: 60, passScore: 60, times: 1 };
                    this.dialogManageShow = true;
                    break;
                case "edit": //编辑
                    if (this.multipleSelection.length != 1) {
                        this.$message.closeAll();
                        this.$message.warning("请选择一项进行修改");
                        return;
                    }
                    this.queryPost();
                    this.manageForm = Object.assign({}, this.multipleSelection[0]);
                    this.$set(this.manageForm, 'date', [this.manageForm.startDate, this.manageForm.endDate]);
                    this.dialogManageShow = true;
                    break;
                case "manageConfirm": //确定
                    this.$refs['manageForm'].validate((valid) => {
                        if (valid) {
                            if(this.manageForm.id == null){
                                this.manageForm.date[0] = this.manageForm.date[0] + " 00:00:00";
                                this.manageForm.date[1] = this.manageForm.date[1] + " 23:59:59";
                            }
                            this.saveOrUpdate();
                        } else {
                            return false;
                        }
                    });
                    break;
                case "delete": //删除
                    if (this.multipleSelection.length == 0) {
                        this.$message.closeAll();
                        this.$message.warning("请至少选择一项进行删除");
                        return;
                    }
                    this.$confirm('此操作将删除所选中的考试策略配置, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.delete();
                    }).catch(() => { });
                    break;
                default:
                    break;
            }
        },

        /**
         * 格式化日期
         */
        formatDate: function (str) {
            return str.substring(0, 10)
        },

        /**
         * 表格选中事件
         * @param {*} val 
         */
        tableColumnCheckEvent: function (val) {
            this.multipleSelection = val;
        },

        /**
         * 翻页操作
         */
        handlePageChange: function (val) {
            this.pageIndex = val;
            this.query();
        },

        /**
         * 查询岗位列表
         */
        queryPost: function () {
            this.$post({
                url: 'org/query',
                params: {
                    orgType: 3
                }
            }).then(response => {
                var postList = new Array;
                response.data.forEach(elem => {
                    var count = 0;
                    postList.forEach(item => {
                        if (elem.name == item.name) {
                            count += 1;
                        }
                    });
                    if (count == 0)
                        postList.push(elem);
                });
                this.postList = postList;
            });
        },

        /**
         * 新增或修改
         */
        saveOrUpdate: function () {
            var startDate = new Date(this.manageForm.date[0]);
            var endDate = new Date(this.manageForm.date[1]);
            console.log(this.manageForm.date)
            console.log("-->",endDate)
            this.$post({
                url: "/examStrategy/saveOrUpdate",
                params: {
                    id: this.manageForm.id,
                    name: this.manageForm.name,
                    duration: this.manageForm.duration,
                    passScore: this.manageForm.passScore,
                    postName: this.manageForm.postName,
                    times: this.manageForm.times,
                    startDate: startDate,
                    endDate: endDate
                }
            }, true).then(res => {
                this.manageForm = {};
                this.dialogManageShow = false;
                this.$message.closeAll();
                this.$message.success("添加成功");
                this.query();
            });
        },

        /**
         * 批量删除
         */
        delete: function () {
            var ids = new Array();
            this.multipleSelection.forEach(elem => {
                ids.push(elem.id);
            });
            this.$post({
                url: "/examStrategy/delete",
                params: {
                    ids: ids
                }
            }, true).then(res => {
                this.$message.closeAll();
                this.$message.success("删除成功");
                this.query();
            });
        },

        /**
         * 查询
         */
        query: function () {
            this.$post({
                url: 'examStrategy/queryByPage',
                params: {
                    keyWord: this.searchContent,
                    pageIndex: this.pageIndex,
                    pageSize: this.pageSize,
                    startDate: this.date == null ? null : new Date((this.date[0] + " 00:00:00")),
                    endDate: this.date == null ? null : new Date((this.date[1] + " 23:59:59"))
                }
            }, true).then(response => {
                this.total = response.total;
                this.tableData = response.data;
            });
        },
    }
}